/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { LoginUser, setsetId } from "../api";
import {
  HEADERS,
  setUserId,
  setOrgId,
  setLeaPId,
  setDepId,
  setFname,
  setLname,
  setDname,
  setroleName,
  setHeadId,
  ForgotPassword,
} from "../api";
import timetrekImage from "../../images/leave-primary.png";
import logo from "../../images/DK_logo.png";
import { Link } from "react-router-dom";
import LOGO from "../../images/landing.png";
import { FiEye, FiEyeOff } from "react-icons/fi"; // Assuming you are using react-icons package
import { setUserEmail } from "../api";
const MySwal = withReactContent(Swal);
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const handleSuccessfulLogin = (userData) => {
    setUserId(userData.user_id);
    setUserEmail(userData.email);
    setOrgId(userData.organization_id);
    setLeaPId(userData.leave_policy);
    setDepId(userData.department_id);
    setDname(userData.department_name);
    setFname(userData.first_name);
    setLname(userData.last_name);
    setsetId(userData.set_id);
    setroleName(userData.user_role_name);
    setHeadId(userData.is_head);
    sessionStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("subscription_plan", userData.subscription_plan_name);
    localStorage.setItem("organisation_id", userData.organization_id);
    // console.log("Login success, navigating to dashboard");
    navigate("/dashboard");
  };

  const handleLogin = async () => {
    try {
      setFormSubmitted(true);

      // Validate email
      if (!email) {
        setEmailError("Please enter your email");
      } else {
        setEmailError("");
      }

      // Validate password
      if (!password) {
        setPasswordError("Please enter your password");
      } else {
        setPasswordError("");
      }

      // If either field is empty, stop here
      if (!email || !password) {
        return;
      }

      setLoading(true);

      const requestBody = {
        email: email,
        users_password: password,
      };

      const response = await axios.post(LoginUser, requestBody, {
        headers: HEADERS,
      });

      // console.log("Login response:", response);

      const response_code = response?.data?.response_code;
      const response_description = response?.data?.response_description;
      const response_data = response?.data?.data;
      const role_name = response?.data?.role_name;

      if (response_code === "0000" && Array.isArray(response_data)) {
        const userData = response_data[0];
        setUserId(userData.user_id);
        setUserEmail(userData.email);
        setOrgId(userData.organization_id);
        setLeaPId(userData.leave_policy);
        setDepId(userData.department_id);
        setDname(userData.department_name);
        setFname(userData.first_name);
        setLname(userData.last_name);
        setsetId(userData.set_id);
        setroleName(userData.user_role_name);
        setHeadId(userData.is_head);

        sessionStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem(
          "subscription_plan",
          userData.subscription_plan_name
        );
        localStorage.setItem("organisation_id", userData.organization_id);

        // console.log("Login success, navigating to dashboard");
        navigate("/dashboard");

        // ⚠️ Enterprise plan expired & user is root
      } else if (role_name === "root user") {
        Swal.fire({
          icon: "warning",
          title: "Enterprise Plan Expired",
          text: response_description,
          confirmButtonColor: "#2D7D9F",
        }).then(() => {
          const userData = response.data;
          if (userData?.user_id) {
            setUserId(userData.user_id);
            setUserEmail(userData.email);
            setOrgId(userData.organization_id);
            setLeaPId(userData.leave_policy);
            setDepId(userData.department_id);
            setDname(userData.department_name);
            setFname(userData.first_name);
            setLname(userData.last_name);
            setsetId(userData.set_id);
            setroleName(userData.user_role_name);
            setHeadId(userData.is_head);

            sessionStorage.setItem("user", JSON.stringify(userData));
            localStorage.setItem(
              "subscription_plan",
              userData.subscription_plan_name
            );
            localStorage.setItem("organisation_id", userData.organization_id);

            // console.log("Navigating to billing upgrade");
            navigate("/billing-upgrade");
          } else {
            console.error("User data is invalid or missing.");
            Swal.fire({
              icon: "error",
              title: "Login Failed",
              text: "User information not found.",
              confirmButtonColor: "#2D7D9F",
            });
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: response_description || "An unknown error occurred.",
          confirmButtonColor: "#2D7D9F",
        });
      }
    } catch (error) {
      console.error("Login failed:", error.message);
      Swal.fire({
        icon: "error",
        title: "Login Error",
        text: "Something went wrong while logging in.",
        confirmButtonColor: "#2D7D9F",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPasswordd = (e) => {
    e.preventDefault();
    navigate("/reset-pass");
  };

  return (
    <>
      <div className="registration-form-container  ">
        <a href="." className="logo">
          <img src={logo} alt="Time Trek" height="60" />
        </a>
        <div className="row">
          <div className="col-md-12">
            <div className="registration-form shadow mt-5">
              <div className="justify-content-center text-center mt-4">
                <img src={timetrekImage} alt="Time Trek" height="70" />
              </div>
              <h2 className="or mt-4">
                <strong>LOGIN</strong>
              </h2>
              <form className="input-form pb-4 pt-2">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={handleKeyPress}
                  />
                  {formSubmitted && !email && (
                    <span className="warning">{emailError}</span>
                  )}
                </div>
                <div className="form-group pb-1 mt-2">
                  <div>
                    <div style={{ position: "relative" }}>
                      <label>Password</label>
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={handleKeyPress}
                      />
                      <span
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FiEyeOff /> : <FiEye />}
                      </span>
                    </div>
                    {formSubmitted && !password && (
                      <span className="warning text-right">
                        {passwordError}
                      </span>
                    )}
                  </div>
                  <div className="d-flex flex-end justify-content-end pb-3 mt-2">
                    <a
                      href="#"
                      onClick={handleForgotPasswordd}
                      className="small-link"
                      style={{
                        textDecoration: "none",
                        fontSize: "14px",
                        color: "#505050",
                      }}
                    >
                      Forgot Password?
                    </a>
                  </div>
                </div>

                <button
                  className="login-button"
                  type="button"
                  onClick={handleLogin}
                >
                  {loading ? "Logging In..." : "Login"}
                </button>

                <div className="d-flex  gap-2 mt-3 justify-content-center">
                  <span
                    style={{ fontSize: "14px" }}
                    className="justify-content-center d-flex flex-row"
                  >
                    Don't have an account?
                  </span>
                  <Link
                    to="/registration"
                    className="small-link"
                    style={{
                      textDecoration: "none",
                      color: "#2d7d9f",
                      fontSize: "14px",
                    }}
                  >
                    Sign Up
                  </Link>
                </div>
              </form>
            </div>
          </div>
          {/* <div className="col-md-6 mt-5 d-flex jutify-content-center m-auto position-absolute">
            <img src={LOGO} alt="Time Trek" height="" />

          </div> */}
        </div>
      </div>
    </>
  );
};

export { Login };
